// extracted by mini-css-extract-plugin
export default {"players":"Players_players__pg+1u","title":"Players_title__GR-Sj"};